.wrapper {
  background: $bg-container-l1;
  width: 100%;
  height: 100%;
  padding: max(16px, 2vh);
}
